export const MAX_WEI: bigint = 2n ** 256n - 1n;
